import PropTypes from 'prop-types';
import React from 'react';
import { BaseCard, BaseCardBody, BaseCardHeader } from '@unite-us/ui';
import EligibilityAssessments from '../eligibility/EligibilityAssessments';

const SECTION_TITLE_CLASS = 'text-base font-semibold leading-6 text-brand-blue';

export default function EligibilityAssessmentSection({
  className,
  embeddedMode,
  params,
  sectionTitle,
}) {
  const content = (
    <EligibilityAssessments
      embeddedMode
      params={params}
    />
  );

  if (embeddedMode) {
    return (
      <div className={className}>
        <div className={`mb-4 ${SECTION_TITLE_CLASS}`}>
          {sectionTitle}
        </div>
        {content}
      </div>
    );
  }

  return (
    <BaseCard>
      <BaseCardHeader title={<span className={SECTION_TITLE_CLASS}>Eligibility Assessment</span>} />
      <BaseCardBody>
        {content}
      </BaseCardBody>
    </BaseCard>
  );
}

EligibilityAssessmentSection.propTypes = {
  className: PropTypes.string,
  embeddedMode: PropTypes.bool,
  params: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  sectionTitle: PropTypes.string,
};

EligibilityAssessmentSection.defaultProps = {
  className: '',
  embeddedMode: false,
  sectionTitle: 'Eligibility Assessments',
};
